<template>
      <b-card variant="warning">    
        <b-row> 
            <b-col>
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" viewBox="0 350 500 250" height="80"><defs><path d="M150 448.33L150 598.33L0 598.33L0 348.33L50 348.33L50 448.33L150 448.33ZM275 498.33L275 598.33L225 598.33L225 498.33L175 498.33L175 448.33L325 448.33L325 498.33L275 498.33ZM500 498.33L400 498.33L400 598.33L350 598.33L350 448.33L500 448.33L500 498.33ZM50 548.33L100 548.33L100 498.33L50 498.33L50 548.33Z" id="logo"></path></defs>
              <g><use xlink:href="#logo" class="logosvg"></use></g></svg>  
                <b-btn @click="closeBox" type="button" class="close">
              &#x2573;</b-btn>
              <p>Crypto made simple.</p>
              <hr>
            </b-col>
        </b-row>       
            <btr-first 
            v-if = "content === 'first'"
            v-on:happyclick = "happyClick"
            ></btr-first> 
            <btr-terms v-if = "content === 'terms'"></btr-terms> 
            <btr-about v-if = "content === 'about'"></btr-about> 
            <btr-donate v-if = "content === 'donate'"></btr-donate> 
            <btr-disclaim v-if = "content === 'disclaim'"></btr-disclaim> 
            <btr-privacy v-if = "content === 'privacy'"></btr-privacy> 
            <btr-addcoin v-if = "content === 'addcoin'"></btr-addcoin>
            <btr-happyoffer v-if = "content === 'happyoffer'"
            v-bind:user = 'user'
            ></btr-happyoffer>
        <hr>
        <b-row class="justify-content-md-center text-center">
          <b-col sm ='12' md="2">
            <svg aria-hidden="true" preserveAspectRatio="xMidYMid meet" width="7.5vw" data-prefix="fas" id="smile" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512"><path fill="currentColor" d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 144c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"></path></svg>
          </b-col>
          <b-col sm ='12' md="12" xl='4'>
            <h3> Spread the Happiness </h3>
            <btr-social></btr-social>
            Happiness Tokens are an excellent way to get some practice receiving, sending and storing tokens with virtually no risk. 
          </b-col>
        </b-row>
      </b-card>
</template>

<script>

// import Chart from 'chart.js'

export default {
  props: {
    content: '',
    user: {
      default: {
        displayName: 'hello'
      }
    }
  },
  data () {
    return {
      status: 'updated'
    }
  },
  computed: {
  },
  created () {},
  methods: {
    happyClick () {
      console.log('Splash Happyclick')
      this.$emit('close-splash', { splashContent: 'happyoffer', splashBox: true })
    },
    closeBox: function () {
      console.log('emit event to close about box', true)
      this.$emit('close-splash', { splashContent: 'none', splashBox: false })
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
#head{
  padding-left: 1px;
  font-size: 100%;
}
.card-header{
  background-color:rgba(255, 192, 7, 1);
  font-family: 'Lato';
  color: white;
  padding: 7px;
  height: 35px;
} 
.card-footer{
  border: 1px solid white;
  background: grey;
  color: white;
}
#commentsButton {
  color: rgba(255, 192, 7, 1);
  background-color:rgba(108, 117, 125, 1);
}
.close{
  color: grey;
  background: none;
  font-size: 2rem;
  border: none;
  text-shadow: none;
  opacity: 1;
}
.socialicon {
  margin: 10px;
  color: grey;
}
#smile {
  display: block;
  margin: auto;
  color: rgba(255, 192, 7, 0.7)
}
</style>




// WEBPACK FOOTER //
// src/components/splash/btr-splash.vue